import axios from 'axios';

// Store a reference to the alert function that will be set by the app
let showErrorAlert = null;

// Function to set the alert function from the app
export const setAlertFunction = (alertFunction) => {
  showErrorAlert = alertFunction;
};

// Set up axios interceptor to handle token expiration globally
const setupAxiosInterceptor = () => {
  // Response interceptor to handle 401 errors (token expiration)
  axios.interceptors.response.use(
    (response) => {
      // If response is successful, just return it
      return response;
    },
    (error) => {
      // Check if the error is a 401 (Unauthorized)
      if (error.response && error.response.status === 401) {
        // Get the request URL to check if this is an authentication endpoint
        const requestUrl = error.config?.url || '';

        // Don't trigger logout for authentication endpoints or permission-based endpoints
        const isAuthEndpoint = requestUrl.includes('/auth/signin') ||
                              requestUrl.includes('/auth/signup') ||
                              requestUrl.includes('/auth/confirm') ||
                              requestUrl.includes('/auth/forgot-password') ||
                              requestUrl.includes('/auth/reset-password');

        // Don't trigger logout for permission-based endpoints that should handle 401/403 gracefully
        const isPermissionEndpoint = requestUrl.includes('/detention/monthly-summary') ||
                                   requestUrl.includes('/detention/available-months') ||
                                   requestUrl.includes('/audit/') ||
                                   requestUrl.includes('/user/management');

        if (!isAuthEndpoint && !isPermissionEndpoint) {
          // Token expired or unauthorized, logging out user

          // Clear all stored tokens
          localStorage.removeItem('idToken');
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');

          // Show a user-friendly message using custom alert if available, fallback to browser alert
          if (showErrorAlert) {
            showErrorAlert('Your session has expired. Please log in again.');
          } else {
            // Fallback to browser alert if custom alert is not available
            alert('Your session has expired. Please log in again.');
          }

          // Redirect to login page
          window.location.href = '/#/login';
        } else {
          // Authentication failed for login attempt
        }
      }

      // For all other errors, just reject the promise
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptor;
